import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {
  IBankInfoAgreement,
  IBankInfoCards,
  IBankInfoCredential,
} from 'src/app/interfaces/accountant.interfaces';
import {IDropdownObject} from 'src/app/interfaces/dropdown-object.interface';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';

@Component({
  selector: 'app-new-bank-popup',
  templateUrl: './new-bank-popup.component.html',
  styleUrls: ['./new-bank-popup.component.scss'],
})
export class NewBankPopupComponent implements OnInit {
  public newBankForm!: UntypedFormGroup;
  public firstCardNumber: IBankInfoCards[] = [
    {
      id: null,
      bankInfoId: 0,
      cardNumber: null,
      endDate: null,
    },
  ];
  public firstCredential: IBankInfoCredential[] = [
    {
      id: null,
      login: null,
      passwordFilePath: null,
      keyFilePath: null,
      backupPasswordFilePath: null,
      backupKeyFilePath: null,
      cloudPasswordFilePath: null,
      cloudKeyFilePath: null,
      comment: null,
      bankInfoId: 0,
    },
  ];
  public firstAgreement: IBankInfoAgreement[] = [
    {
      id: null,
      agreementNo: null,
      agreementStartDate: null,
      agreementEndDate: null,
      nda: null,
      comment: null,
      bankInfoId: 0,
    },
  ];
  public isDatePickerOpened!: boolean;

  constructor(
    private _fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    @Optional()
    @Inject(DIALOG_DATA)
    public data: {
      peId: number;
      dropdown: IDropdownObject[];
    }
  ) {}

  ngOnInit(): void {
    this.newBankForm = this._fb.group({
      id: new UntypedFormControl(null),
      peId: new UntypedFormControl(this.data.peId),
      bankName: new UntypedFormControl(null),
      usdiban: new UntypedFormControl(null),
      uahiban: new UntypedFormControl(null),
      swiftCode: new UntypedFormControl(null),
      cards: new UntypedFormArray([]),
      bankCredentials: new UntypedFormArray([]),
      agreementInfos: new UntypedFormArray([]),
    });
  }

  get cardsArray(): UntypedFormArray {
    return this.newBankForm.get('cards') as UntypedFormArray;
  }

  get bankCredentialsArray(): UntypedFormArray {
    return this.newBankForm.get('bankCredentials') as UntypedFormArray;
  }

  get agreementInfosArray(): UntypedFormArray {
    return this.newBankForm.get('agreementInfos') as UntypedFormArray;
  }

  createFormGroup(
    data: IBankInfoCredential[] | IBankInfoAgreement[] | IBankInfoCards[],
    control: string
  ) {
    const newGroupArray = data.map(
      (fields: IBankInfoCredential | IBankInfoAgreement | IBankInfoCards) => {
        const formGroup = this._fb.group({
          ...fields,
        });
        return formGroup;
      }
    );
    const groupArray: UntypedFormArray = this._fb.array(newGroupArray);
    this.newBankForm.setControl(control, groupArray);
  }

  createCardsGroup() {
    const newCard = this._fb.group({
      ...this.firstCardNumber[0],
    });
    if (this.cardsArray.length === 0) {
      this.createFormGroup(this.firstCardNumber, 'cards');
    } else {
      this.cardsArray.push(newCard);
    }
  }

  createCredentialsGroup() {
    const newCredential = this._fb.group({
      ...this.firstCredential[0],
    });
    if (this.bankCredentialsArray.length === 0) {
      this.createFormGroup(this.firstCredential, 'bankCredentials');
    } else {
      this.bankCredentialsArray.push(newCredential);
    }
  }

  createAgreementGroup() {
    const newAgreement = this._fb.group({
      ...this.firstAgreement[0],
    });
    if (this.agreementInfosArray.length === 0) {
      this.createFormGroup(this.firstAgreement, 'agreementInfos');
    } else {
      this.agreementInfosArray.push(newAgreement);
    }
  }

  save() {
    this.dialogRef.close(this.newBankForm.value);
  }

  close() {
    this.dialogRef.close();
  }
}
